import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroProgPedidoLista {
  lastSetDefault: Date;

  DC5FECENT_DE: Date | undefined;
  DC5FECENT_ATE: Date | undefined;
  DC5EMISSAO_DE: Date | undefined;
  DC5EMISSAO_ATE: Date | undefined;
  CC5NUM: string;
  NC5XDSEMAN: number;
}

export class FiltroProgPedidoLista {

  dados: IFiltroProgPedidoLista;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-lista-programacao-pedido';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroProgPedidoLista) => {
      if (filtro) {

        const {
          lastSetDefault,
          DC5FECENT_DE,
          DC5FECENT_ATE,
          DC5EMISSAO_DE,
          DC5EMISSAO_ATE,
          CC5NUM,
          NC5XDSEMAN
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
            DC5FECENT_DE: DC5FECENT_DE ? new Date(DC5FECENT_DE) : undefined,
            DC5FECENT_ATE: DC5FECENT_ATE ? new Date(DC5FECENT_ATE) : undefined,
            DC5EMISSAO_DE: DC5EMISSAO_DE ? new Date(DC5EMISSAO_DE) : undefined,
            DC5EMISSAO_ATE: DC5EMISSAO_ATE ? new Date(DC5EMISSAO_ATE) : undefined,
            CC5NUM: CC5NUM,
            NC5XDSEMAN: NC5XDSEMAN
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroProgPedidoLista => {
    return {
      lastSetDefault: new Date(),
      DC5FECENT_DE: this.getData(-7),
      DC5FECENT_ATE: new Date(),
      DC5EMISSAO_DE: this.getData(-7),
      DC5EMISSAO_ATE: new Date(),
      CC5NUM: '',
      NC5XDSEMAN: 1
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
